import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useMemo } from "react";

const classNames = {
  icon: `TargetLinkIcon`,
  link: `TargetLink`
};

export function useTargetLinkStyles() {
  return useMemo(
    () => mergeStyleSets({
      icon: [
        classNames.icon,
        {
          height: `.7em !important`,
          marginLeft: `5px`,
          verticalAlign: `baseline !important`,
          width: `.7em !important`
        }
      ],
      link: [
        classNames.link,
        {
          ":hover, :active, :link, :visited": {
            textDecoration: `none`
          }
        }
      ]
    }),
    []
  );
}
